import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const ExportExcel = ({ tableId, filename = "report.xlsx" }) => {
  const downloadExcel = () => {
    const table = document.getElementById(tableId);
    if (!table) {
      console.error(`Table with id="${tableId}" not found`);
      return;
    }

    const ws = XLSX.utils.table_to_sheet(table, { raw: true });

    // Build merge info from rowSpan and colSpan
    const merges = [];
    const rows = [...table.querySelectorAll("tr")];

    let rowIndex = 0;
    rows.forEach((row) => {
      let colIndex = 0;
      [...row.cells].forEach((cell) => {
        const rowspan = cell.rowSpan || 1;
        const colspan = cell.colSpan || 1;

        if (rowspan > 1 || colspan > 1) {
          merges.push({
            s: { r: rowIndex, c: colIndex }, // start
            e: { r: rowIndex + rowspan - 1, c: colIndex + colspan - 1 }, // end
          });
        }

        colIndex += colspan;
      });
      rowIndex++;
    });

    ws["!merges"] = merges;

    // Create workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    // Export as file
    // Export as file (correct MIME type)
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, filename);
  };

  return (
    <button onClick={downloadExcel} id="CSV">
      Export Excel
    </button>
  );
};

export default ExportExcel;
